import { c as _c } from "react/compiler-runtime";
import useProductListingData from 'hooks/useProductListingData';
import { GET_CATEGORY_PAGE } from 'mocks/queries';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import useUserLocation from 'global-state/userLocation/useUserLocation';
const useCategoryPageData = t0 => {
  const $ = _c(6);
  const {
    slug
  } = t0;
  const userLocation = useUserLocation();
  const zipCode = userLocation?.zip ?? "";
  const t1 = userLocation?.stateShortName;
  let t2;
  if ($[0] !== t1) {
    t2 = getVisitorLocationQueryVariables(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== slug || $[3] !== t2 || $[4] !== zipCode) {
    t3 = {
      variables: {
        slug,
        zipCode,
        ...t2
      }
    };
    $[2] = slug;
    $[3] = t2;
    $[4] = zipCode;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const pageData = useProductListingData(GET_CATEGORY_PAGE, t3);
  return pageData;
};
export default useCategoryPageData;